import React, { useState } from "react";
import colorLogo from "../assets/images/color logo.png";
import { Link, useNavigate } from "react-router-dom";
import { FaPowerOff, FaQuestion, FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";

const Navbar = () => {
  const { user } = useSelector((state) => state.user);
  const [logoutModal, setLogoutModal] = useState(false);
  const closeLogoutModal = () => {
    setLogoutModal(false);
  };
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("sdUser");
    navigate("/login", { replace: true });
  };
  return (
    <>
      <div className="container-fluid bg-white p-2 sticky-top d-flex align-items-center justify-content-between">
        <div className="logo">
          {user.Account_Status === "Active" ? (
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={colorLogo} alt="logo" loading="lazy" />
            </Link>
          ) : (
            <div onClick={() => window.scrollTo(0, 0)}>
              <img src={colorLogo} alt="logo" loading="lazy" />
            </div>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-between gap-2">
          {user.Account_Status === "Active" && (
            <>
              <Link to="/help" className="button d-sm-block d-none">
                Help & Support
              </Link>
              <Link to="/help" className="button d-sm-none d-block">
                <FaQuestion />
              </Link>
            </>
          )}
          {user.Account_Status === "Enrolled" && (
            <div className="my-tooltip-wrapper">
              <button className="button">
                <FaUser />
                <div className="my-tooltip">
                  <p>{user.Full_Name}</p>
                </div>
              </button>
            </div>
          )}
          <button className="button" onClick={() => setLogoutModal(true)}>
            <FaPowerOff />
          </button>
        </div>
      </div>

      <div className={`custom-modal-container ${logoutModal ? "active" : ""}`}>
        <div
          className="custom-modal-background"
          onClick={() => setLogoutModal(false)}
        ></div>
        <div className="custom-modal-box">
          <div className="body py-4 p-2 text-center rounded">
            <h2>Logout?</h2>
            <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
              <button
                className="button text-center"
                onClick={logout}
                style={{ minWidth: "80px" }}
              >
                Yes
              </button>
              <button
                className="button text-center"
                onClick={closeLogoutModal}
                style={{ minWidth: "80px" }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
